export default function PropertyDetailsApi({ makeRequest, buildRequest }) {

    // Leases
    function getLeasesByProperty(propertyId) {
        return buildRequest().then(function (req) {
            return makeRequest(req.get(`/api/PropertyDetails/Leases/${propertyId}`));
        });
    }

    function upsertLease(payload) {
        return buildRequest().then(function (req) {
            return makeRequest(req.post('/api/PropertyDetails/Leases/Upsert', payload));
        });
    }

    function deleteLease(leaseId) {
        return buildRequest().then(function (req) {
            return makeRequest(req.delete(`/api/PropertyDetails/Leases/${leaseId}`));
        });
    }

    // Lease Dates
    function getLeaseDatesByLease(leaseId) {
        return buildRequest().then(function (req) {
            return makeRequest(req.get(`/api/PropertyDetails/LeaseDates/${leaseId}`));
        });
    }

    function upsertLeaseDate(payload) {
        return buildRequest().then(function (req) {
            return makeRequest(req.post('/api/PropertyDetails/LeaseDates/Upsert', payload));
        });
    }

    function deleteLeaseDate(leaseDateId) {
        return buildRequest().then(function (req) {
            return makeRequest(req.delete(`/api/PropertyDetails/LeaseDates/${leaseDateId}`));
        });
    }

    // Lease Notes
    function getLeaseNotesByLease(leaseId) {
        return buildRequest().then(function (req) {
            return makeRequest(req.get(`/api/PropertyDetails/LeaseNotes/${leaseId}`));
        });
    }

    function upsertLeaseNote(payload) {
        return buildRequest().then(function (req) {
            return makeRequest(req.post('/api/PropertyDetails/LeaseNotes/Upsert', payload));
        });
    }

    function deleteLeaseNote(leaseNoteId) {
        return buildRequest().then(function (req) {
            return makeRequest(req.delete(`/api/PropertyDetails/LeaseNotes/${leaseNoteId}`));
        });
    }

    // Projects
    function getProjectsByProperty(propertyId) {
        return buildRequest().then(function (req) {
            return makeRequest(req.get(`/api/PropertyDetails/Projects/${propertyId}`));
        });
    }

    function upsertProject(payload) {
        return buildRequest().then(function (req) {
            return makeRequest(req.post('/api/PropertyDetails/Projects/Upsert', payload));
        });
    }

    function deleteProject(projectId) {
        return buildRequest().then(function (req) {
            return makeRequest(req.delete(`/api/PropertyDetails/Projects/${projectId}`));
        });
    }

    // Issues
    function getIssuesByProperty(propertyId) {
        return buildRequest().then(function (req) {
            return makeRequest(req.get(`/api/PropertyDetails/Issues/${propertyId}`));
        });
    }

    function upsertIssue(payload) {
        return buildRequest().then(function (req) {
            return makeRequest(req.post('/api/PropertyDetails/Issues/Upsert', payload));
        });
    }

    function deleteIssue(issueId) {
        return buildRequest().then(function (req) {
            return makeRequest(req.delete(`/api/PropertyDetails/Issues/${issueId}`));
        });
    }

    // Rooms
    function getRoomsByProperty(propertyId) {
        return buildRequest().then(function (req) {
            return makeRequest(req.get(`/api/PropertyDetails/Rooms/${propertyId}`));
        });
    }

    function upsertRoom(payload) {
        return buildRequest().then(function (req) {
            return makeRequest(req.post('/api/PropertyDetails/Rooms/Upsert', payload));
        });
    }

    function deleteRoom(roomId) {
        return buildRequest().then(function (req) {
            return makeRequest(req.delete(`/api/PropertyDetails/Rooms/${roomId}`));
        });
    }

    // Building Types
    function getBuildingTypes() {
        return buildRequest().then(function (req) {
            return makeRequest(req.get('/api/PropertyDetails/BuildingTypes'));
        });
    }

    function upsertBuildingType(payload) {
        return buildRequest().then(function (req) {
            return makeRequest(req.post('/api/PropertyDetails/BuildingTypes/Upsert', payload));
        });
    }

    function deleteBuildingType(buildingTypeId) {
        return buildRequest().then(function (req) {
            return makeRequest(req.delete(`/api/PropertyDetails/BuildingTypes/${buildingTypeId}`));
        });
    }

    // Property Statuses
    function getPropertyStatuses() {
        return buildRequest().then(function (req) {
            return makeRequest(req.get('/api/PropertyDetails/PropertyStatuses'));
        });
    }

    function upsertPropertyStatus(payload) {
        return buildRequest().then(function (req) {
            return makeRequest(req.post('/api/PropertyDetails/PropertyStatuses/Upsert', payload));
        });
    }

    function deletePropertyStatus(propertyStatusId) {
        return buildRequest().then(function (req) {
            return makeRequest(req.delete(`/api/PropertyDetails/PropertyStatuses/${propertyStatusId}`));
        });
    }

    // Lease Types
    function getLeaseTypes() {
        return buildRequest().then(function (req) {
            return makeRequest(req.get('/api/PropertyDetails/LeaseTypes'));
        });
    }

    function upsertLeaseType(payload) {
        return buildRequest().then(function (req) {
            return makeRequest(req.post('/api/PropertyDetails/LeaseTypes/Upsert', payload));
        });
    }

    function deleteLeaseType(leaseTypeId) {
        return buildRequest().then(function (req) {
            return makeRequest(req.delete(`/api/PropertyDetails/LeaseTypes/${leaseTypeId}`));
        });
    }

    // Issue Types
    function getIssueTypes() {
        return buildRequest().then(function (req) {
            return makeRequest(req.get('/api/PropertyDetails/IssueTypes'));
        });
    }

    function upsertIssueType(payload) {
        return buildRequest().then(function (req) {
            return makeRequest(req.post('/api/PropertyDetails/IssueTypes/Upsert', payload));
        });
    }

    function deleteIssueType(issueTypeId) {
        return buildRequest().then(function (req) {
            return makeRequest(req.delete(`/api/PropertyDetails/IssueTypes/${issueTypeId}`));
        });
    }

    // Room Types
    function getRoomTypes() {
        return buildRequest().then(function (req) {
            return makeRequest(req.get('/api/PropertyDetails/RoomTypes'));
        });
    }

    function upsertRoomType(payload) {
        return buildRequest().then(function (req) {
            return makeRequest(req.post('/api/PropertyDetails/RoomTypes/Upsert', payload));
        });
    }

    function deleteRoomType(roomTypeId) {
        return buildRequest().then(function (req) {
            return makeRequest(req.delete(`/api/PropertyDetails/RoomTypes/${roomTypeId}`));
        });
    }

    // Project Statuses
    function getProjectStatuses() {
        return buildRequest().then(function (req) {
            return makeRequest(req.get('/api/PropertyDetails/ProjectStatuses'));
        });
    }

    function upsertProjectStatus(payload) {
        return buildRequest().then(function (req) {
            return makeRequest(req.post('/api/PropertyDetails/ProjectStatuses/Upsert', payload));
        });
    }

    function deleteProjectStatus(projectStatusId) {
        return buildRequest().then(function (req) {
            return makeRequest(req.delete(`/api/PropertyDetails/ProjectStatuses/${projectStatusId}`));
        });
    }

    // Project Types
    function getProjectTypes() {
        return buildRequest().then(function (req) {
            return makeRequest(req.get('/api/PropertyDetails/ProjectTypes'));
        });
    }

    function upsertProjectType(payload) {
        return buildRequest().then(function (req) {
            return makeRequest(req.post('/api/PropertyDetails/ProjectTypes/Upsert', payload));
        });
    }

    function deleteProjectType(projectTypeId) {
        return buildRequest().then(function (req) {
            return makeRequest(req.delete(`/api/PropertyDetails/ProjectTypes/${projectTypeId}`));
        });
    }

    // Lessors
    function getLessors() {
        return buildRequest().then(function (req) {
            return makeRequest(req.get('/api/PropertyDetails/Lessors'));
        });
    }

    function getLessor(lessorId) {
        return buildRequest().then(function (req) {
            return makeRequest(req.get(`/api/PropertyDetails/Lessors/${lessorId}`));
        });
    }

    function upsertLessor(payload) {
        return buildRequest().then(function (req) {
            return makeRequest(req.post('/api/PropertyDetails/Lessors/Upsert', payload));
        });
    }

    function deleteLessor(lessorId) {
        return buildRequest().then(function (req) {
            return makeRequest(req.delete(`/api/PropertyDetails/Lessors/${lessorId}`));
        });
    }

    return {
        getLeasesByProperty,
        upsertLease,
        deleteLease,
        getLeaseDatesByLease,
        upsertLeaseDate,
        deleteLeaseDate,
        getLeaseNotesByLease,
        upsertLeaseNote,
        deleteLeaseNote,
        getProjectsByProperty,
        upsertProject,
        deleteProject,
        getIssuesByProperty,
        upsertIssue,
        deleteIssue,
        getRoomsByProperty,
        upsertRoom,
        deleteRoom,
        getBuildingTypes,
        upsertBuildingType,
        deleteBuildingType,
        getPropertyStatuses,
        upsertPropertyStatus,
        deletePropertyStatus,
        getLeaseTypes,
        upsertLeaseType,
        deleteLeaseType,
        getIssueTypes,
        upsertIssueType,
        deleteIssueType,
        getRoomTypes,
        upsertRoomType,
        deleteRoomType,
        getProjectStatuses,
        upsertProjectStatus,
        deleteProjectStatus,
        getProjectTypes,
        upsertProjectType,
        deleteProjectType,
        getLessors,
        getLessor,
        upsertLessor,
        deleteLessor,
    };
}
